












































import { Component, Mixins, Prop, Vue, Ref } from 'vue-property-decorator'
import Question from '@/competences/entities/question'
import Competence from '@/competences/entities/competence'
import questionsService from '@/competences/services/questions-service'
import QuestionFilter from '@/competences/entities/question-filter'
import snacks from '@/app/services/snacks'

@Component
export default class QuestionsDialog extends Vue {
  private dialog = false

  private model = new Competence()
  private questions: Question[] = []

  @Prop({ type: Boolean, default: false })
  public disabled!: boolean

  public openQuestions(model: Competence) {
    this.model = model
    this.dialog = true
    this.fetchAll()
  }

  public close() {
    this.$emit('close')
    this.dialog = false
  }

  private async fetchAll() {
    const filter = new QuestionFilter()
    filter.competenceId = this.model.id
    this.questions = await questionsService.findAllAsync(filter)
  }

  private async create(question: Question) {
    question.competenceId = this.model.id
    await questionsService.createAsync(question)
    this.fetchAll()
    snacks.success('competences.components.questions-dialog.created')
  }

  private async change(question: Question) {
    await questionsService.updateAsync(question)
    // this.fetchAll()
    snacks.success('competences.components.questions-dialog.changed')
  }

  private async remove(question: Question) {
    await questionsService.removeAsync(question.id)
    this.fetchAll()
    snacks.success('competences.components.questions-dialog.removed')
  }

  private async up(question: Question) {
    await questionsService.upAsync(question.id)
    this.fetchAll()
  }

  private async down(question: Question) {
    await questionsService.downAsync(question.id)
    this.fetchAll()
  }
}
